//import Installi18n from "@benefit-estimator/plugins/modules/Installi18n";
import InstallAxios from "@benefit-estimator/plugins/modules/InstallAxios";
import InstallVuetify from "@benefit-estimator/plugins/modules/InstallVuetify";
import InstallMoment from "@benefit-estimator/plugins/modules/InstallMoment";
import ApplySettings from "@benefit-estimator/plugins/modules/ApplySettings";

const InstallPlugins = (app, store = null) => {
  //Installi18n(app);
  InstallAxios(app);
  InstallVuetify(app);
  InstallMoment(app);

  ApplySettings(app, store);
};

export default InstallPlugins;
